<template>
  <div class="app-root">
    <div :aria-hidden="showMobileAccessNotice ? 'true' : null">
      <router-view/>
    </div>
    <MobileAccessNotice
        v-if="showMobileAccessNotice"
        @acknowledge="acknowledgeMobileAccess"
    />
  </div>
</template>

<script>
import MobileAccessNotice from './components/app/MobileAccessNotice.vue'

const {isMobilePhone} = require('./utils/mobileAccess.cjs')

export default {
  name: 'AppRoot',
  components: {MobileAccessNotice},
  data() {
    // 根组件首屏完成设备识别，避免手机用户先操作到未完整适配的后台页面。
    return {
      mobilePhoneDetected: isMobilePhone(typeof navigator === 'undefined' ? null : navigator),
      mobileAccessAcknowledged: false,
    }
  },
  computed: {
    showMobileAccessNotice() {
      return this.mobilePhoneDetected && !this.mobileAccessAcknowledged
    },
  },
  methods: {
    acknowledgeMobileAccess() {
      // 仅在当前应用生命周期内放行，刷新或重新打开后台时仍会再次提醒。
      this.mobileAccessAcknowledged = true
    },
  },
}
</script>
